import DataType from '@opsbase/lib-datatype/DataType';
import i18n from '@opsbase/lib-i18n';
import Palette from '@opsbase/lib-palette';
import useOpDefinitions from '@opsbase/react-gql-hooks/opdefinition/useOpDefinitions';
import useOrgTemplateRollOut from '@opsbase/react-gql-hooks/orgtemplate/useOrgTemplateRollOut';
import useCss from '@opsbase/web-css/useCss/useCss';
import DataChooserValueList from '@opsbase/web-data-choosers/DataChooser/DataChooserValueList';
import useSelection from '@opsbase/web-data-selection/useSelection';
import useSelectionActions from '@opsbase/web-data-selection/useSelectionActions';
import ConfirmDialog from '@opsbase/web-dialogs/ConfirmDialog';
import DialogSize from '@opsbase/web-dialogs/Dialog/DialogSize';
import Divider from '@opsbase/web-layout/Divider/Divider';
import Pane from '@opsbase/web-layout/Pane/Pane';
import Vertical from '@opsbase/web-layout/Vertical/Vertical';
import useParams from '@opsbase/web-nav/useParams';
import useNotificationActions from '@opsbase/web-notification/useNotificationActions';
import Checkbox from '@opsbase/web-ui/Checkbox/Checkbox';
import Text from '@opsbase/web-ui/Text';
import React, { useCallback, useMemo, useState } from 'react';
const makeMyClasses = () => ({
    pane: {
        height: 100,
    },
});
export function OrgTemplateRollOutDialog() {
    const dataType = DataType.ORGTEMPLATE;
    const { selecteds } = useSelection(dataType);
    const { clearSelection } = useSelectionActions(dataType);
    const { id } = useParams();
    const ids = useMemo(() => (id === 'selected' ? selecteds.map(o => o.id) : [id]), [id, selecteds]);
    const copyText = i18n.t('rollout');
    const cancelText = i18n.t('cancel');
    const { raise } = useNotificationActions();
    const { data } = useOpDefinitions({ variables: { orgTemplateId: ids } });
    const text = i18n.t('confirm-template-rollout', { count: (data === null || data === void 0 ? void 0 : data.length) || 1 });
    const rollOutOrgTemplate = useOrgTemplateRollOut();
    const [publish, setPublish] = useState(true);
    const myCss = useCss(makeMyClasses);
    const handleAction = useCallback(() => {
        clearSelection();
        return raise(rollOutOrgTemplate({ ids, publish }), i18n.t('template-rollout-successful'));
    }, [clearSelection, raise, rollOutOrgTemplate, ids, publish]);
    return (React.createElement(ConfirmDialog, { size: DialogSize.X450_Y250, onConfirm: handleAction, agreeText: copyText, notAgreeText: cancelText, color: Palette.positive },
        React.createElement(Vertical, { gutter: true },
            React.createElement(Text, null, text),
            React.createElement(Divider, null),
            React.createElement(Pane, { scroll: true, classes: { root: myCss.pane } },
                React.createElement(DataChooserValueList, { disabled: true, alwaysWrap: true, noBorder: true, required: false, value: data === null || data === void 0 ? void 0 : data.map(d => ({ ...d, type: DataType.OPDEFINITION })), type: DataType.OPDEFINITION })),
            React.createElement(Divider, { style: { bottom: 50, width: '94%', position: 'absolute' } }),
            React.createElement("div", { style: { bottom: 10, position: 'absolute' } },
                React.createElement(Checkbox, { label: i18n.t('confirm-publish-operation', { count: (data === null || data === void 0 ? void 0 : data.length) || 1 }), checked: publish, onChange: setPublish })))));
}
export default OrgTemplateRollOutDialog;
